export const passwordMinLength = 8;

export const getSpecialCharacters = () => ['@', '!', '#', '$', '%', '^', '&']

export const checkPassword = (password) => {
    if (password && password.length < passwordMinLength) {
        return false;
    }

    // первый символ тоже экранируем
    const specialCharacters = `\\${(getSpecialCharacters().join('\\'))}`;

    return new RegExp(`(?=.*[0-9])(?=.*[${getSpecialCharacters()}])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z${getSpecialCharacters()}]{8,}`).test(password);
}